import { useEffect, useState } from "react";

/**
 * Floating FEYNLAB Certified badge.
 * Hidden on the hero — appears smoothly once the user starts scrolling
 * down. Pinned to the bottom-right corner. Uses the same liquid-glass
 * style as the top header banner.
 */

const FEYNLAB_URL =
  "https://www.feynlab.com/what-is-ceramic-coating-for-cars/?srsltid=AfmBOoqeAs1GIMPY_U3NzbtlfbD8eJeWAiQD_hXf4wmmnGSJw42JFglY";

// Shared liquid-glass styling (matches Header.jsx top banner)
const glassStyle = {
  background:
    "linear-gradient(135deg, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0.03) 45%, rgba(255,255,255,0.02) 60%, rgba(255,255,255,0.09) 100%)",
  backdropFilter: "blur(28px) saturate(180%)",
  WebkitBackdropFilter: "blur(28px) saturate(180%)",
  border: "1px solid rgba(255,255,255,0.16)",
  boxShadow:
    "inset 0 1px 0 rgba(255,255,255,0.35)",
};

export default function FloatingFeynlabBadge() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show as soon as the user starts scrolling down
      setVisible(window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  const visibilityStyles = {
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0)" : "translateY(16px)",
    transition: "opacity 360ms ease-out, transform 360ms ease-out",
    pointerEvents: visible ? "auto" : "none",
  };

  // The PNG has a solid black background — use mix-blend-mode: screen so
  // the black drops out and only the white "FEYNLAB" + gold "Certified"
  // artwork floats over the glass.
  const imgBlend = {
    mixBlendMode: "screen",
  };

  return (
    <>
      {/* Mobile small badge — fixed */}
      <a
        data-testid="floating-feynlab-badge-mobile"
        href={FEYNLAB_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="FEYNLAB Certified Installer"
        style={{ zIndex: 2147483647, ...glassStyle, ...visibilityStyles }}
        className="lg:hidden fixed right-4 bottom-3 inline-flex items-center justify-center rounded-full overflow-hidden h-[41px] px-4"
      >
        <img
          src="/images/feynlab-button.png"
          alt="FEYNLAB Certified"
          className="h-8 w-auto select-none"
          style={imgBlend}
          draggable="false"
        />
      </a>

      {/* Desktop large badge — fixed */}
      <a
        data-testid="floating-feynlab-badge-desktop"
        href={FEYNLAB_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="FEYNLAB Certified Installer"
        style={{ zIndex: 2147483647, ...glassStyle, ...visibilityStyles }}
        className="hidden lg:inline-flex fixed right-4 bottom-4 rounded-full overflow-hidden h-[58px] px-6 items-center justify-center"
      >
        <img
          src="/images/feynlab-button.png"
          alt="FEYNLAB Certified"
          className="h-11 w-auto select-none"
          style={imgBlend}
          draggable="false"
        />
      </a>
    </>
  );
}
